import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    elecConsumption: 0,
    elecRate: 0,
    electricEstimated: true,
    gasConsumption: 0,
    gasRate: 0,
    gasEstimated: true,
    selectedTariff: {},
    tariffId: 0,
    selfConsumption: 'mdg003_homeallday', // % of Solar Energy used by household in the day
    selfgen: false // Self Generated Lead for commission purposes
}

const energySlice = createSlice({
    name: 'energy',
    initialState,
    reducers: {
        setElecConsumption: (state, action) => {
            state.elecConsumption = action.payload
        },
        setElecRate: (state, action) => {
            state.elecRate = action.payload
        },
        setElectricEstimated: (state, action) => {
            state.electricEstimated = action.payload
        },
        setGasConsumption: (state, action) => {
            state.gasConsumption = action.payload
        },
        setGasRate: (state, action) => {
            state.gasRate = action.payload
        },
        setGasEstimated: (state, action) => {
            state.gasEstimated = action.payload
        },
        setSelectedTariff: (state, action) => {
            state.selectedTariff = action.payload
            if (action.payload?.id) {
                state.tariffId = action.payload.id
            }
        },
        setTariffId: (state, action) => {
            state.tariffId = action.payload
        },
        setSelfConsumption: (state, action) => {
            state.selfConsumption = action.payload
        },
        setSelfGen: (state, action) => {
            state.selfgen = action.payload
        },
        updateEnergyFromQuote: (state, action) => {
            // Bulk update from loaded quote data
            const data = action.payload
            if (data.elecConsumption !== undefined) state.elecConsumption = data.elecConsumption
            if (data.elecconsumption !== undefined) state.elecConsumption = data.elecconsumption
            if (data.elecRate !== undefined) state.elecRate = data.elecRate
            if (data.elecrate !== undefined) state.elecRate = data.elecrate
            if (data.electricEstimated !== undefined) state.electricEstimated = data.electricEstimated
            if (data.electric_estimated !== undefined) state.electricEstimated = data.electric_estimated
            if (data.gasConsumption !== undefined) state.gasConsumption = data.gasConsumption
            if (data.gasconsumption !== undefined) state.gasConsumption = data.gasconsumption
            if (data.gasRate !== undefined) state.gasRate = data.gasRate
            if (data.gasrate !== undefined) state.gasRate = data.gasrate
            if (data.gasEstimated !== undefined) state.gasEstimated = data.gasEstimated
            if (data.gas_estimated !== undefined) state.gasEstimated = data.gas_estimated
            if (data.selectedTariff !== undefined) state.selectedTariff = data.selectedTariff
            if (data.selected_tariff !== undefined) state.selectedTariff = data.selected_tariff
            if (data.tariffId !== undefined) state.tariffId = data.tariffId
            if (data.tariff_id !== undefined) state.tariffId = data.tariff_id
            if (data.selfConsumption !== undefined) state.selfConsumption = data.selfConsumption
            if (data.selfconsumption !== undefined) state.selfConsumption = data.selfconsumption
            if (data.selfgen !== undefined) state.selfgen = data.selfgen
        },
        resetEnergy: () => initialState
    }
})

export const {
    setElecConsumption,
    setElecRate,
    setElectricEstimated,
    setGasConsumption,
    setGasRate,
    setGasEstimated,
    setSelectedTariff,
    setTariffId,
    setSelfConsumption,
    setSelfGen,
    updateEnergyFromQuote,
    resetEnergy
} = energySlice.actions

// Selectors
export const selectElecConsumption = (state) => state.energy.elecConsumption
export const selectElecRate = (state) => state.energy.elecRate
export const selectElectricEstimated = (state) => state.energy.electricEstimated
export const selectGasConsumption = (state) => state.energy.gasConsumption
export const selectGasRate = (state) => state.energy.gasRate
export const selectGasEstimated = (state) => state.energy.gasEstimated
export const selectSelectedTariff = (state) => state.energy.selectedTariff
export const selectTariffId = (state) => state.energy.tariffId
export const selectSelfConsumption = (state) => state.energy.selfConsumption
export const selectSelfGen = (state) => state.energy.selfgen

// Computed selectors
export const selectAnnualElecCost = (state) =>
    state.energy.elecConsumption * state.energy.elecRate

export const selectAnnualGasCost = (state) =>
    state.energy.gasConsumption * state.energy.gasRate

export default energySlice.reducer
